import { colors, s16 } from '@ardoq/design-tokens';
import { COLOR_BAR_SELECTOR } from '@ardoq/page-layout';
import styled, { css, CSSProperties } from 'styled-components';
import { BigButton } from './BigButton';

export const ColorBarBigButton = styled(BigButton)<{
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
}>`
  gap: ${s16};
  border: 1px solid ${colors.borderAction};
  width: ${({ width }) => width ?? 'unset'};
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};
  ${COLOR_BAR_SELECTOR} {
    height: 100%;
    margin: 0;
    flex-shrink: 0;
  }
  &:disabled {
    background-color: ${colors.surfaceDisabled};
  }
`;
